import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * `cn` — combine + dedupe Tailwind classes.
 *
 * Mirrors the gen5-pwa-fresh / shadcn convention. Use it instead of raw
 * string concatenation for any conditional className composition:
 *
 *     <div className={cn("p-4 bg-white", isActive && "bg-blue-50")} />
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
